import { BRANDS_RECEIVED, SET_BRAND } from "../types/brands";

const BrandsReducer = (state, { type, payload }) => {
  switch (type) {
    case BRANDS_RECEIVED:
      return { ...state, brands: payload };
    case SET_BRAND:
      return { ...state, brand: payload };
    default:
      return { ...state };
  }
};

export default BrandsReducer;

